/**
 *
 * @param text - The text to capitalize
 * @returns a capitalized string
 */
export const capitalize = (text: string): string => text.charAt(0).toUpperCase() + text.slice(1)
